import React from 'react';
import RemoteDataProvider from './RemoteDataProvider';

const AccountsContext = React.createContext();

function providesAccounts(Component) {
  class RemoteAccounts extends React.Component {
    render() {
      return (
        <RemoteDataProvider
          scope="dossier"
          baseURL="/accounts"
          isCollection
          updateStrategy="fetch"
          render={(remoteData) => {
            return (
              <AccountsContext.Provider value={remoteData}>
                <Component {...this.props} />
              </AccountsContext.Provider>
            );
          }}
        />
      );
    }
  }

  return RemoteAccounts;
}

function consumesAccounts(Component, provideValueAs = 'accounts') {
  return function ComponentThatConsumesAccounts(props) {
    return (
      <AccountsContext.Consumer>
        {(remoteData) => {
          const consumedProps = {
            remoteAccounts: remoteData,
            [provideValueAs]: remoteData.value,
          };

          return <Component {...props} {...consumedProps} />;
        }}
      </AccountsContext.Consumer>
    );
  };
}

export { providesAccounts, consumesAccounts };
